<template>
    <div>
        <h3 class="is-size-3">Acortador de URL</h3>
        <p>
            <code>POST {{ host }}/api/shortURL</code>
        </p>
        <br />
        <h5 class="is-size-6">El endpoint tiene dos parámetros:</h5>
        <div class="content">
            <ul>
                <li>
                    <strong>url</strong>
                    <ul>
                        <li>Obligatorio</li>
                        <li>Formato de liga (Ej. https://google.com)</li>
                    </ul>
                </li>
                <li>
                    <strong>event</strong>
                    <ul>
                        <li>Opcional</li>
                        <li>Formato (Ej. 'app#execute')</li>
                    </ul>
                </li>
            </ul>
        </div>
        <br />
        <h5 class="is-size-6">
            El endpoint recibe un token de seguridad en el header:
        </h5>
        <pre>
        <code>headers: 
        { 
            "Authentication":"Bearer {TOKEN}",
        }</code>
        </pre>
        <br />
        <h5 class="is-size-6">Respuesta:</h5>
        <pre>
        <code>{
            "status": "success",
            "url": "blcp.mx/l/e639c"
        }</code>
        </pre>
        <hr />
    </div>
</template>

<script>
export default {
    data () {
        return {
            host: process.env.VUE_APP_HOST
        }
    }
}
</script>

<style lang="scss" scoped>
</style>